module.exports = __webpack_public_path__ + "sprites-28.20d8880b4ee489575981.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/sprites/sprites-28.svg
// module id = 7
// module chunks = 2